import { useQuery } from '@tanstack/react-query'
import { listDayforceAgencies } from 'api/admin/dayforce/listDayforceAgencies'
import { dayforceKeys } from './keys'

export const useDayforceAgenciesQuery = () => {
  return useQuery({
    queryKey: dayforceKeys.agencies(),
    queryFn: listDayforceAgencies,
  })
}
